/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon24Solid = forwardRef('DataChartPieA2Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11 2.05C5.947 2.55 2 6.814 2 12c0 5.523 4.477 10 10 10 5.185 0 9.449-3.947 9.95-9H13a2 2 0 0 1-2-2V2.05Z" }),
        React.createElement("path", { d: "M13 2.05A10.003 10.003 0 0 1 21.95 11H13V2.05Z" })));
});
